var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},_vm._l((_vm.slides),function(slide,i){return _c('div',{key:i,staticClass:"slide",class:_vm.getSlideClass(i),style:({ backgroundImage: 'url(' + slide + ')' })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }